import React, { useState } from "react";
import {
  PieChart,
  Pie,
  Sector,
  Tooltip,
  ResponsiveContainer
} from "recharts";

export default function ChartPieDonutActive({ chartData, onSelectSlice }) {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (data, index) => {
    setActiveIndex(index);
    onSelectSlice?.(data);
  };

  if (!Array.isArray(chartData) || chartData.length === 0) {
    return null;
  }

  return (
    <div
      className="
        w-[90px] h-[90px]
        sm:w-[56px] sm:h-[56px]
        md:w-[100px] md:h-[100px]
        flex items-center justify-center
      "
    >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Tooltip formatter={(value) => `(%${Number(value)})`} />

          <Pie
            data={chartData}
            dataKey="visitors"
            nameKey="browser"
            innerRadius="60%"
            outerRadius="80%"
            stroke="none"
            activeIndex={activeIndex}
            onClick={handleClick}
            activeShape={(props) => (
              <Sector {...props} outerRadius={props.outerRadius + 6} />
            )}
            style={{ cursor: "pointer" }}
            labelLine={false}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}